import React from 'react'
import TextTruncate from 'react-text-truncate';

function Texttruncate({ text }) {
  return (
    text ? 
    text?.length > 12 ? text?.slice(0, 12) + '...' : text : null
    // <TextTruncate
    //   line={1}
    //   element="span"
    //   truncateText="…"
    //   text={text}
    // />
  )
}

export default Texttruncate